import { string as yupString, number as yupNumber, ref } from 'yup';

export { object, date, boolean } from 'yup';

export function string() {
  return yupString().typeError(({ originalValue }) => {
    if (!originalValue) {
      return REQUIRED_MESSAGE;
    }
    return 'Este campo deve ser preenchido somente texto';
  });
}

export function time() {
  return string().matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Hora inválida');
}

export function number() {
  return yupNumber()
    .typeError('Este campo deve ser preenchido somente com números')
    .transform((v: any) => (Number.isNaN(v) ? 0 : v));
}

export function email() {
  return string().email('Insira um e-mail válido');
}

const nameRegex = /[a-zA-Z\u00C0-\u00FF ]+/i;

export function name(msg :string = 'Escreva o nome completo') {
  return string()
    .min(2, msg)
    .matches(nameRegex, 'Use somente letras e espaços!');
}

export function password() {
  return string().test(
    'password',
    'A senha deve ter no mínimo 6 digitos',
    (val) => (val?.length || 0) >= 6,
  );
}

export function match(fieldName: string, feedback: string) {
  return string().oneOf([ref(fieldName), null], feedback);
}

export function phone() {
  return string().min(16, 'Telefone inválido');
}

export function message() {
  return string().min(10, 'Mensagem deve conter ao menos 10 caracteres');
}

export const REQUIRED_MESSAGE = 'O campo é obrigatório';
